import React from "react";
import apiProxy from "../../api/apiProxy";
import StoreOverridePage from "./StoreOverridePage.js";

export default props => (
  <StoreOverridePage getScenes={apiProxy.scene.getScenes} />
);
